import PuzzleService from '_services/rest/modules/puzzle';
import { handleResourceLoadError } from '_utils';

export default {
  state: {
    cryptogram: null,
    cryptogramList: null,
  },
  mutations: {
    setCryptogramList(state, response) {
      state.cryptogramList = response;
    },
    setCryptogram(state, cryptogram) {
      state.cryptogram = cryptogram;
    },
  },
  actions: {
    getCryptogram({ commit, dispatch }, id) {
      return PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setCryptogram', response);
        })
        .catch(error => {
          handleResourceLoadError(dispatch, error, 'admin-cryptogram-list');
        });
    },
    getCryptogramList({ commit }, params) {
      PuzzleService.getPuzzles(params)
        .then(response => {
          commit('setCryptogramList', response);
        });
    },
    setCryptogram({ commit }, model) {
      commit('setCryptogram', model);
    },
  },
};
